import { CheckShieldOutline, CloseShieldOutline } from "antd-mobile-icons";
const examPopAction = [
	{ key: "1", icon: <CheckShieldOutline />, text: "通过" },
	{ key: "2", icon: <CloseShieldOutline />, text: "不通过" },
];
export default examPopAction